
<ngx-charts-advanced-pie-chart *ngIf="!isLoading"  class="ui-g-12"  style="padding:0;"
  [scheme]="colorScheme"
  [results]="formattedDataNGX"
  [gradient]="gradient"
  (select)="onSelect($event)"
  (activate)="onActivate($event)"
  (deactivate)="onDeactivate($event)"
  [view]="view">
</ngx-charts-advanced-pie-chart>